import axios from "axios";

export const gmailUserInfo = async (token) => {
  let email = await axios.get(
    `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${token}`
  );
  return email;
};
